// extracted by mini-css-extract-plugin
export default {"template":"Template-module__template__-ef9a","title":"Template-module__title__O0PDM","footer":"Template-module__footer__igZv+"};